var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyPayments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "noun-money-28122",
    xmlns: "http://www.w3.org/2000/svg",
    width: 113.026,
    height: 113.025,
    viewBox: "0 0 113.026 113.025",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_16262",
    "data-name": "Path 16262",
    d: "M56.513,0a56.513,56.513,0,1,0,56.513,56.513A56.513,56.513,0,0,0,56.513,0Zm0,108.016a51.5,51.5,0,1,1,51.5-51.5A51.5,51.5,0,0,1,56.513,108.016Z",
    fill: "#2c53bb"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16263",
    "data-name": "Path 16263",
    d: "M451.8,316.693c-6.105-2.2-8.591-3.763-8.591-6.034,0-1.987,1.491-4.047,6.106-4.047a22.087,22.087,0,0,1,10.222,2.484l2.129-8.023a25.681,25.681,0,0,0-10.364-2.342v-6.247h-6.957v6.744c-7.6,1.42-12,6.318-12,12.636,0,6.887,5.182,10.436,12.778,12.992,5.324,1.774,7.6,3.479,7.6,6.175,0,2.768-2.769,4.4-6.886,4.4a25.058,25.058,0,0,1-11.784-3.124l-2.131,8.306a29.663,29.663,0,0,0,12.07,3.053v6.744h7.028V343.1c8.164-1.348,12.565-6.744,12.565-13.062,0-6.459-3.336-10.364-11.783-13.347Z",
    transform: "translate(-391.237 -264.936)",
    fill: "#2c53bb"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyPayments);
export default __webpack_public_path__ + "static/media/my-payments.98581f2d74272efad31b7b8ebcddc38e.svg";
export { ForwardRef as ReactComponent };